var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        id: "integrate-story-list-with-whatsapp-bot-modal",
        title: _vm.title,
        wrapClassName: "vertical-center-modal",
        visible: _vm.modalVisable,
        footer: null,
      },
      on: {
        visibleChange: function (isVisible) {
          return _vm.$emit("modal-visible2", isVisible)
        },
        cancel: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _vm._l(_vm.cloneChannels, function (item, index) {
        return _c("div", { key: index, staticClass: "list-container" }, [
          _c(
            "div",
            { staticClass: "intergation-channel-name" },
            [
              ["whatsapp-qr", "whatsapp-v1"].includes(item.type)
                ? _c("WhatsappV1", {
                    staticClass: "whatsapp-icon",
                    attrs: { color: "#179d0d" },
                  })
                : item.type === "whatsapp-v2"
                ? _c("WhatsappV2", {
                    staticClass: "whatsapp-icon",
                    attrs: { color: "#179d0d" },
                  })
                : item.type === "whatsapp-unipile"
                ? _c("WhatsappV3", {
                    staticClass: "whatsapp-icon",
                    attrs: { color: "#179d0d" },
                  })
                : item.type === "whatsapp-business-api"
                ? _c("WhatsappBusinessIcon", {
                    staticClass: "whatsapp-icon",
                    attrs: { color: "#179d0d" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: item.name },
                      expression: "{ content: item.name }",
                    },
                  ],
                  staticClass: "channel-name",
                },
                [
                  _vm._v(
                    "\n                " + _vm._s(item.name) + "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mt-1 mb-1" }, [
            _c("span", [
              _vm._v(
                " 👉 " +
                  _vm._s(
                    _vm.$t("whatsappChannel.forwardingChatbotOrLiveAgent")
                  ) +
                  " "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "a-select",
                {
                  attrs: { "default-value": "" },
                  model: {
                    value: item.forward.story,
                    callback: function ($$v) {
                      _vm.$set(item.forward, "story", $$v)
                    },
                    expression: "item.forward.story",
                  },
                },
                [
                  _c(
                    "a-select-option",
                    { attrs: { value: "", selected: true } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("whatsapp_business_api.forwardLiveAgents")
                          )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.filteredStories, function (story) {
                    return _c(
                      "a-select-option",
                      { key: story._id, attrs: { value: story._id } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(story.title) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c(
            "SupsisButton",
            { attrs: { ghost: "" }, on: { click: _vm.close } },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("wp.cancel")) + "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { primary: "", disabled: !_vm.isChanged() },
              on: { click: _vm.updateMultiChannel },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("chatbotv2.save")) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }